import { computed, type ComputedRef } from 'vue'

import { useInsightActionRank } from './useInsightActionRank'

export type InsightActionGate =
  'hidden_role' | 'hidden_flag' | 'hidden_unavailable' | 'loading' | 'no_actions' | 'open'

export interface PreviewGateInput {
  loading: boolean
  errorCode: string
  groupCount: number
  executionEnabled: boolean | undefined
}

export interface UseInsightActionGate {
  mayRequestPreview: ComputedRef<boolean>
  resolve: (preview: PreviewGateInput) => InsightActionGate
}

export function useInsightActionGate(): UseInsightActionGate {
  const { atLeast } = useInsightActionRank()

  const mayRequestPreview = computed(() => atLeast('editor'))

  function resolve(preview: PreviewGateInput): InsightActionGate {
    if (!mayRequestPreview.value) return 'hidden_role'
    if (preview.errorCode === 'PLATFORM_ACTIONS_DISABLED') return 'hidden_flag'
    if (preview.errorCode === 'PERMISSION_DENIED') return 'hidden_role'
    if (preview.errorCode) return 'hidden_unavailable'
    if (preview.loading) return 'loading'
    if (preview.groupCount === 0) return 'no_actions'
    if (preview.executionEnabled === false) return 'hidden_flag'
    return 'open'
  }

  return { mayRequestPreview, resolve }
}
